import React from 'react';
import { Card } from '../ui/card';
import styles from './CftcCards.module.css';

type SummaryCardProps = {
  children: React.ReactNode;
  className?: string;
};

const SummaryCard: React.FC<SummaryCardProps> = ({ children, className }) => (
  <Card className={`${styles.card} ${className || ''}`}>
    {children}
  </Card>
);

export default SummaryCard;
